import * as React from 'react'
import { SVGProps } from 'react'

const SvgWatches = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 20 20" {...props}>
    <path d="M19.047 3.277 16.69.92a.833.833 0 0 0-1.037-.114l-4.72 3.004a6.678 6.678 0 0 1 5.224 5.224l3.004-4.72a.834.834 0 0 0-.114-1.037zM3.081 11.662l-3.004 4.72a.833.833 0 0 0 .114 1.037l2.357 2.357a.842.842 0 0 0 1.037.114l4.72-3.004a6.677 6.677 0 0 1-5.224-5.224z" />
    <path d="M13.744 6.223a5.833 5.833 0 1 0-.631 8.797l.63.632 1.18-1.179-.632-.631a5.834 5.834 0 0 0-.547-7.619Zm-7.34 7.34a4.547 4.547 0 1 1 3.215 1.333 4.517 4.517 0 0 1-3.216-1.332Z" />
    <path d="M12.32 7.648a3.818 3.818 0 1 0-5.401 5.4 3.818 3.818 0 0 0 5.4-5.4Zm-.344 3.534H9.62a.834.834 0 0 1-.79-.57l-.59-1.768 1.582-.527.399 1.198h1.756v1.667Z" />
  </svg>
)

export default SvgWatches
